module.exports = __webpack_public_path__ + "img/Plus.98f3d586.svg";